import { Switch as KSwitch } from "@kobalte/core/switch";
import { ChatPrompt } from "@storytell/cp-client";
import { TbHelpCircleFilled, TbMessage2, TbSparkles } from "solid-icons/tb";
import { Show } from "solid-js";

import { StTooltip, StTooltipTrigger } from "@storytell/ui/tooltip";
import { usePromptBarContext } from "../PromptBarContext";
export const ModeSelector = () => {
  const context = usePromptBarContext();
  const isAgenticMode = () => context.executionMode.value() === ChatPrompt.ExecutionMode.AGENTIC;
  const setMode = (mode: ChatPrompt.ExecutionMode) => {
    context.executionMode.setValue(mode);
  };

  return (
    <StTooltip
      placement="top"
      openDelay={200}
      contentProps={{
        class: "z-50",
      }}
      content={
        <div class="p-3 max-w-xs">
          <div class="flex justify-end">
            <a
              class="inline-flex items-center gap-1 underline text-brand text-xs"
              href="https://go.storytell.ai/learn-modes"
              target="_blank"
              rel="noreferrer"
            >
              <TbHelpCircleFilled />
              Learn more
            </a>
          </div>

          <div class="flex items-start gap-3 mb-3">
            <TbMessage2 class="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
            <div>
              <div class="font-semibold text-sm text-primary-text">Chat Mode</div>
              <div class="text-xs text-secondary-text mt-0.5">
                Lightning-fast, budget-friendly answers from your knowledge base. Your go-to for instant insights and
                daily workflows.
              </div>
            </div>
          </div>
          <div class="flex items-start gap-3 mb-3">
            <TbSparkles class="w-5 h-5 text-violet-500 mt-0.5 flex-shrink-0" />
            <div>
              <div class="font-semibold text-sm text-primary-text">Agentic Mode</div>
              <div class="text-xs text-secondary-text mt-0.5">
                Full-powered AI that searches your knowledge, browses the web, and creates deliverables. Tackles
                complexity with precision.
              </div>
            </div>
          </div>
        </div>
      }
    >
      <StTooltipTrigger
        as={KSwitch}
        class="flex items-center gap-2 cursor-pointer"
        onChange={(checked: boolean) => {
          if (checked) setMode(ChatPrompt.ExecutionMode.AGENTIC);
          else setMode(ChatPrompt.ExecutionMode.CHAT);
        }}
        checked={isAgenticMode()}
      >
        <KSwitch.Input class="peer" />
        <KSwitch.Control class="group/switch relative hover:bg-panel-hover inline-flex items-center border border-muted-border dark:border-primary-border h-8 w-16 pl-[0.2rem] rounded-full transition-colors duration-250">
          <div class="absolute inset-0 pointer-events-nonex rounded-full flex items-center justify-between px-[0.55rem] opacity-70">
            <TbMessage2 class="w-4 h-4 text-blue-800 dark:text-blue-200" />
            <TbSparkles class="w-4 h-4 text-violet-800 dark:text-violet-200" />
          </div>
          <KSwitch.Thumb
            class={`h-6.5 w-6.5 grid place-content-center absolute rounded-full transition-all duration-250 data-[checked]:translate-x-[1.9rem]
                text-white
                bg-blue-600
                group-data-[checked]/switch:bg-violet-600
              `}
          >
            <Show when={isAgenticMode()} fallback={<TbMessage2 class="w-4 h-4" />}>
              <TbSparkles class="w-4 h-4" />
            </Show>
          </KSwitch.Thumb>
        </KSwitch.Control>
      </StTooltipTrigger>
    </StTooltip>
  );
};
